import PropTypes from 'prop-types';

import { LAUNCH_CALENDAR_SHOES_PLACEHOLDER_IMAGE } from 'constants/launchCalendar';
import { constructMSAImageUrl } from 'helpers';
import useMartyContext from 'hooks/useMartyContext';

import styles from 'styles/components/account/subscriptions/productSubscriptionListItem.scss';

const THUMBNAIL_WIDTH_PIXELS = 136;
const THUMBNAIL_HEIGHT_PIXELS = 102;

const msaImageDimensions = {
  width: THUMBNAIL_WIDTH_PIXELS * 2,
  height: THUMBNAIL_HEIGHT_PIXELS * 2
};

const ProductSubscriptionListItem = ({ productName, asin, styleId, brand, color, size, width, imageId, subscribed, onChange }) => {
  const { testId } = useMartyContext();
  const imageUrl = imageId ? constructMSAImageUrl(imageId, msaImageDimensions) : LAUNCH_CALENDAR_SHOES_PLACEHOLDER_IMAGE;
  const id = asin ?? styleId;

  return (
    <tr data-test-id={testId('productSubscriptionListItem')}>
      <td>
        <div className={styles.wrapper}>
          <div className={styles.checkboxContainer}>
            <input name={productName} id={id} checked={subscribed} onChange={onChange} value={id} type="checkbox" />
            <label htmlFor={id}>{productName}</label>
          </div>
          <div className={styles.mProduct}>
            <div className={styles.image}>
              <img src={imageUrl} alt={productName} />
            </div>
          </div>
          <div className={styles.itemContainer}>
            <div>
              <div className={styles.productName} data-test-id={testId('productSubBrandProductName')}>
                {productName}
              </div>
            </div>
            <div className={styles.itemDetails}>
              {asin && <div data-test-id={testId('productSubAsin')}>ASIN: {asin}</div>}
              <div data-test-id={testId('productSubBrand')}>Brand: {brand}</div>
              <div data-test-id={testId('productSubColor')}>Color: {color}</div>
              {size && <div data-test-id={testId('productSubSize')}>Size: {size}</div>}
              {width && <div data-test-id={testId('productSubWidth')}>Width: {width}</div>}
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
};

const eitherAsinOrStyleIdRequiredCheck = (props, propName, componentName) => {
  if (!props.asin && !props.styleId) {
    return new Error(`Either asin or styleId is required by ${componentName} component.`);
  }
};

ProductSubscriptionListItem.propTypes = {
  productName: PropTypes.string.isRequired,
  asin: PropTypes.string && eitherAsinOrStyleIdRequiredCheck,
  styleId: PropTypes.number && eitherAsinOrStyleIdRequiredCheck,
  brand: PropTypes.string.isRequired,
  imageId: PropTypes.string,
  subscribed: PropTypes.bool.isRequired,
  productUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func
};

export default ProductSubscriptionListItem;
